import { render, staticRenderFns } from "./ProCard3.vue?vue&type=template&id=b1f05130&scoped=true"
import script from "./ProCard3.vue?vue&type=script&lang=js"
export * from "./ProCard3.vue?vue&type=script&lang=js"
import style0 from "./ProCard3.vue?vue&type=style&index=0&id=b1f05130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f05130",
  null
  
)

export default component.exports